import { useState, useCallback } from 'react';
import { Modal, InputNumber, Space } from 'antd';
import { LexicalEditor } from 'lexical';
import { INSERT_TABLE_COMMAND } from '@lexical/table';
import styles from '../RichTextEditor.module.scss';
import { useTranslation } from 'react-i18next';
import { TextBox } from '@/components/TextBox';

interface InsertTableButtonProps {
  editor: LexicalEditor;
  trigger: React.ReactNode;
}

export function InsertTableButton({ editor, trigger }: InsertTableButtonProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(2);
  const [cols, setCols] = useState(2);

  const insert = useCallback(() => {
    editor.dispatchCommand(INSERT_TABLE_COMMAND, {
      rows: String(rows),
      columns: String(cols),
    });
    setOpen(false);
  }, [editor, rows, cols]);

  return (
    <>
      <span onClick={() => setOpen(true)}>{trigger}</span>

      <Modal
        title={t('editor.insert.tableTitle')}
        visible={open}
        onCancel={() => setOpen(false)}
        width={400}
        onOk={insert}
      >
        <Space direction="vertical" className={styles.tableModal}>
          <TextBox label={t('editor.insert.rows')}>
            <InputNumber
              min={1}
              max={20}
              value={rows}
              onChange={(v) => setRows(v || 1)}
            />
          </TextBox>
          <TextBox label={t('editor.insert.columns')}>
            <InputNumber
              min={1}
              max={20}
              value={cols}
              onChange={(v) => setCols(v || 1)}
            />
          </TextBox>
        </Space>
      </Modal>
    </>
  );
}
